// ============================================================================
// TIM SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'tim-sort',
  name: 'Tim Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n log n) average/worst, O(n) best',
    space: 'O(n)'
  },
  description: 'Tim Sort is a hybrid stable sorting algorithm, derived from merge sort and insertion sort, designed to perform well on many kinds of real-world data.'
};
export type MetaType = typeof meta;
